<template>
  <div class="home-container">
    <div>
      <b-navbar id="main-navbar" type="dark" variant="dark">

        <b-navbar-nav>
          <b-nav-item v-b-toggle.sidebar-left>
            <font-awesome-icon id="left-sidebar-toggle" class="navbar-icon ml-2 mr-2" icon="bars"/>
          </b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav>
          <router-link to="/home" tag="b-nav-item" @click.native="updateListCategory('listCategoryHome')">
            <font-awesome-icon class="navbar-icon ml-3 mr-2" icon="home"/>
          </router-link>
        </b-navbar-nav>

        <!-- Image and text -->
        <b-navbar-brand class="mx-auto">
          <img src="./../assets/stuff_to_do_logo.png" class="d-inline-block align-top logo" alt="Stuff To-Do logo">
          <span v-show="browserWidth >= 576" class="brand-text">Stuff To-Do</span>
        </b-navbar-brand>

        <b-navbar-nav
            v-if="homeSelectedComponent === 'inbox' || homeSelectedComponent === 'assigned' || homeSelectedComponent === 'personalList' || homeSelectedComponent === 'collaborativeList' || homeSelectedComponent === 'personalTaskList' || homeSelectedComponent === 'collaborativeTaskList' || homeSelectedComponent === 'collaboratorDetails'">
          <b-nav-item-dropdown
              v-if="homeSelectedComponent === 'inbox' || (homeSelectedComponent === 'collaborativeTaskList' && (collaborativeTaskListSelectedTab === 'All Task' || collaborativeTaskListSelectedTab === 'My Task') && isCollaborativeListAdministrator)"
              right no-caret>
            <template v-slot:button-content>
              <font-awesome-icon class="navbar-icon ml-2 mr-3" icon="ellipsis-v"/>
            </template>
            <b-dropdown-item @click="openTaskListOptionModal('Sort by')" v-b-modal.task-list-option-modal>Sort by
            </b-dropdown-item>
            <b-dropdown-item @click="openTaskListOptionModal('Filter by')" v-b-modal.task-list-option-modal>Filter by
            </b-dropdown-item>
            <b-dropdown-item @click="openTaskListOptionModal('Clear completed tasks')" v-b-modal.task-list-option-modal>
              Clear completed tasks
            </b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item-dropdown
              v-if="homeSelectedComponent === 'assigned' || (homeSelectedComponent === 'collaborativeTaskList' && (collaborativeTaskListSelectedTab === 'All Task' || collaborativeTaskListSelectedTab === 'My Task') && !isCollaborativeListAdministrator)"
              right no-caret>
            <template v-slot:button-content>
              <font-awesome-icon class="navbar-icon ml-2 mr-3" icon="ellipsis-v"/>
            </template>
            <b-dropdown-item @click="openTaskListOptionModal('Sort by')" v-b-modal.task-list-option-modal>Sort by
            </b-dropdown-item>
            <b-dropdown-item @click="openTaskListOptionModal('Filter by')" v-b-modal.task-list-option-modal>Filter by
            </b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item-dropdown v-if="homeSelectedComponent === 'personalTaskList'" right no-caret>
            <template v-slot:button-content>
              <font-awesome-icon class="navbar-icon ml-2 mr-3" icon="ellipsis-v"/>
            </template>
            <b-dropdown-item @click="openTaskListOptionModal('Sort by')" v-b-modal.task-list-option-modal>Sort by
            </b-dropdown-item>
            <b-dropdown-item @click="openTaskListOptionModal('Filter by')" v-b-modal.task-list-option-modal>Filter by
            </b-dropdown-item>
            <b-dropdown-item @click="openTaskListOptionModal('Edit list details')" v-b-modal.task-list-option-modal>Edit
              list details
            </b-dropdown-item>
            <b-dropdown-item @click="openTaskListOptionModal('Clear completed tasks')" v-b-modal.task-list-option-modal>
              Clear completed tasks
            </b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item-dropdown
              v-if="(homeSelectedComponent === 'collaboratorDetails' && isCollaborativeListAdministrator && !isCollaborativeListOwner)"
              right no-caret>
            <template v-slot:button-content>
              <font-awesome-icon class="navbar-icon ml-2 mr-3" icon="ellipsis-v"/>
            </template>
            <b-dropdown-item @click="openCollaboratorOptionModal('Change collaborator role')"
                             v-b-modal.collaborator-option-modal>Change collaborator role
            </b-dropdown-item>
            <b-dropdown-item @click="openCollaboratorOptionModal('Remove collaborator')"
                             v-b-modal.collaborator-option-modal>Remove collaborator
            </b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>

        <b-navbar-nav
            v-if="homeSelectedComponent === 'viewCollaborators' && isCollaborativeListAdministrator">
          <b-nav-item @click="openCreationModal" v-b-modal.creation-modal>
            <font-awesome-icon class="navbar-icon ml-2 mr-3" icon="user-plus"/>
          </b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav v-b-toggle.sidebar-right>
          <b-nav-item>
            <font-awesome-icon id="right-sidebar-toggle" class="navbar-icon ml-2 mr-2" icon="bell"/>
          </b-nav-item>
        </b-navbar-nav>

      </b-navbar>
    </div>

    <div>
      <b-sidebar id="sidebar-left" title="Navigation" no-header no-close-on-esc backdrop-variant="dark" backdrop>
        <div class="px-3 py-2">
          <b-row class="personal-information-row">
            <b-col class="col-3">
              <b-img v-if="$store.getters.user.data.photoURL" class="profile-picture"
                     :src="$store.getters.user.data.photoURL" rounded="circle"
                     alt="User profile picture"></b-img>

              <b-img v-else class="profile-picture" :src="require('../assets/default_profile.png')" rounded="circle"
                     alt="User profile picture"></b-img>
            </b-col>
            <b-col>
              <p class="personal-information-text">{{
                  truncateUserInformation($store.getters.user.data.displayName)
                }}</p>
              <p class="personal-information-text">{{ truncateUserInformation($store.getters.user.data.email) }}</p>
            </b-col>
          </b-row>
          <router-link :to="{ name: 'Account Details'}" tag="b-button" class="account-details-button"
                       @click.native="updateListCategory('accountDetails')">Account Details
          </router-link>
          <hr>
          <router-link to="/home" tag="p" active-class="active-list-category" exact class="list-category"
                       @click.native="updateListCategory('listCategoryHome')">Home
          </router-link>
          <router-link to="/inbox" tag="p" active-class="active-list-category" exact class="list-category"
                       @click.native="updateListCategory('inbox')">Inbox
          </router-link>
          <router-link to="/important" tag="p" active-class="active-list-category" class="list-category" exact
                       @click.native="updateListCategory('important')">Important
          </router-link>
          <router-link to="/today" tag="p" active-class="active-list-category" exact class="list-category"
                       @click.native="updateListCategory('today')">Today
          </router-link>
          <router-link to="/assigned" tag="p" active-class="active-list-category" exact class="list-category"
                       @click.native="updateListCategory('assigned')">Assigned
          </router-link>
          <router-link to="/planned" tag="p" active-class="active-list-category" exact class="list-category"
                       @click.native="updateListCategory('planned')">Planned
          </router-link>
          <router-link to="/overdue" tag="p" active-class="active-list-category" exact class="list-category"
                       @click.native="updateListCategory('overdue')">Overdue
          </router-link>
          <hr>
          <router-link to="/personalList" tag="p" active-class="active-list-category" exact class="list-category"
                       @click.native="updateListCategory('personalList')">Personal List
          </router-link>
          <router-link to="/collaborativeList" tag="p" active-class="active-list-category" exact class="list-category"
                       @click.native="updateListCategory('collaborativeList')">Collaborative List
          </router-link>
        </div>
      </b-sidebar>
    </div>

    <div>
      <b-sidebar id="sidebar-right" title="Notification" no-header no-close-on-esc right backdrop-variant="dark"
                 backdrop>
        <div class="px-3 py-2">
          <h2>Notifications</h2>
          <p>Your notification center.</p>
          <hr>
          <div class="notification-container">
            <div v-if="showNotificationPlaceholderImage && !hideNotificationPlaceholderWhenInitialLoad"
                 class="no-notification-container">
              <b-img class="no-notification-picture" :src="require('../assets/no_notification.png')"
                     alt="No notification picture"></b-img>
              <h2>No notification</h2>
              <p>Currently there is nothing new</p>
            </div>

            <notification v-else v-for="notification in notificationDocuments" :key="notification.id"
                          :notification-details="notification"></notification>
          </div>
          <b-button class="clear-notification-button" block @click="clearNotification">Clear notifications</b-button>
        </div>
      </b-sidebar>
    </div>

    <!-- Creation Modal -->
    <b-modal id="creation-modal" :title="creationModalTitle" scrollable no-close-on-backdrop hide-footer>
      <component :is="creationModalSelectedComponent"></component>
    </b-modal>

    <!-- Task List Option -->
    <b-modal id="task-list-option-modal" :title="taskListOptionModalTitle" scrollable no-close-on-backdrop hide-footer>
      <component :is="taskListOptionModalSelectedComponent"></component>
    </b-modal>

    <!-- List Option -->
    <b-modal id="list-option-modal" :title="listOptionModalTitle" scrollable no-close-on-backdrop hide-footer>
      <component :is="listOptionModalSelectedComponent"></component>
    </b-modal>

    <!-- Collaborator Option -->
    <b-modal id="collaborator-option-modal" :title="collaboratorOptionModalTitle" scrollable no-close-on-backdrop
             hide-footer>
      <component :is="collaboratorOptionModalSelectedComponent"></component>
    </b-modal>

    <b-modal
        id="loading-modal"
        size="sm"
        centered
        no-close-on-backdrop
        hide-header
        hide-footer>
      <img
          width="265px"
          class="center-image"
          src="../assets/animated_loading.gif"
          alt="loading animation">
    </b-modal>
  </div>
</template>

<script>
import ListCategoryHome from "../components/list_templates/ListCategoryHome"
import Inbox from "../components/list_templates/Inbox.vue"
import Important from "../components/list_templates/Important.vue"
import Today from "../components/list_templates/Today.vue"
import Assigned from "../components/list_templates/Assigned.vue"
import Planned from "../components/list_templates/Planned.vue"
import Overdue from "../components/list_templates/Overdue.vue"
import PersonalList from "../components/list_templates/PersonalList.vue"
import CollaborativeList from "../components/list_templates/CollaborativeList.vue"
import Notification from "../components/notification_template/Notification"

import PersonalListCreation from "../components/modals/list_creation_modals/PersonalListCreation"
import CollaborativeListCreation from "../components/modals/list_creation_modals/CollaborativeListCreation"
import PersonalTaskCreation from "../components/modals/task_creation_modals/PersonalTaskCreation"
import CollaborativeTaskCreation from "../components/modals/task_creation_modals/CollaborativeTaskCreation"

import PersonalTaskList from "../components/list_templates/PersonalTaskList"
import CollaborativeTaskList from "../components/list_templates/CollaborativeTaskList"

import ViewCollaborators from "../components/collaborator_templates/ViewCollaborators"
import CollaboratorDetails from "../components/collaborator_templates/CollaboratorDetails"
import InviteListCollaborator from "../components/collaborator_templates/InviteListCollaborator"
import TransferListOwnership from "../components/collaborator_templates/TransferListOwnership"

// Modals
import TaskListSortBy from "../components/modals/task_list_option_modals/TaskListSortBy"
import TaskListFilterBy from "../components/modals/task_list_option_modals/TaskListFilterBy"
import TaskListClearCompletedTasks from "../components/modals/task_list_option_modals/TaskListClearCompletedTasks"
import TaskListEditListDetails from "../components/modals/task_list_option_modals/TaskListEditListDetails"
import ChangeCollaboratorRole from "../components/modals/collaborator_option_modals/ChangeCollaboratorRole"
import RemoveCollaborator from "../components/modals/collaborator_option_modals/RemoveCollaborator"

import {mapGetters, mapActions} from 'vuex'
import {db} from "../main";

export default {
  components: {
    listCategoryHome: ListCategoryHome,
    inbox: Inbox,
    important: Important,
    today: Today,
    assigned: Assigned,
    planned: Planned,
    overdue: Overdue,
    personalList: PersonalList,
    collaborativeList: CollaborativeList,
    notification: Notification,
    personalListCreation: PersonalListCreation,
    collaborativeListCreation: CollaborativeListCreation,
    personalTaskCreation: PersonalTaskCreation,
    collaborativeTaskCreation: CollaborativeTaskCreation,
    personalTaskList: PersonalTaskList,
    collaborativeTaskList: CollaborativeTaskList,
    viewCollaborators: ViewCollaborators,
    collaboratorDetails: CollaboratorDetails,
    inviteListCollaborator: InviteListCollaborator,
    transferListOwnership: TransferListOwnership,
    // Modals
    taskListSortBy: TaskListSortBy,
    taskListFilterBy: TaskListFilterBy,
    taskListClearCompletedTasks: TaskListClearCompletedTasks,
    taskListEditListDetails: TaskListEditListDetails,
    changeCollaboratorRole: ChangeCollaboratorRole,
    removeCollaborator: RemoveCollaborator
  },
  data() {
    return {
      showNotificationPlaceholderImage: null,
      hideNotificationPlaceholderWhenInitialLoad: true,
      browserWidth: window.innerWidth,
      taskListOptionModalSelectedComponent: '',
      taskListOptionModalTitle: '',
      listOptionModalSelectedComponent: '',
      listOptionModalTitle: '',
      collaboratorOptionModalSelectedComponent: '',
      collaboratorOptionModalTitle: '',
      notificationDocuments: []
    }
  },
  methods: {
    ...mapActions([
      "updateListCategory"
    ]),
    openCreationModal() {
      this.$store.dispatch('setupCreationModal')
      this.showModal('creation-modal')
    },
    openTaskListOptionModal(optionSelected) {
      if (optionSelected === 'Sort by') {
        this.taskListOptionModalSelectedComponent = 'taskListSortBy'
        this.taskListOptionModalTitle = 'Sort by'
      } else if (optionSelected === 'Filter by') {
        this.taskListOptionModalSelectedComponent = 'taskListFilterBy'
        this.taskListOptionModalTitle = 'Filter by'
      } else if (optionSelected === 'Clear completed tasks') {
        this.taskListOptionModalSelectedComponent = 'taskListClearCompletedTasks'
        this.taskListOptionModalTitle = 'Clear completed tasks'
      } else if (optionSelected === 'Edit list details') {
        this.taskListOptionModalSelectedComponent = 'taskListEditListDetails'
        this.taskListOptionModalTitle = 'Edit list details'
      }
    },
    openCollaboratorOptionModal(optionSelected) {
      if (optionSelected === 'Change collaborator role') {
        this.collaboratorOptionModalSelectedComponent = 'changeCollaboratorRole'
        this.collaboratorOptionModalTitle = 'Change collaborator role'
      } else if (optionSelected === 'Remove collaborator') {
        this.collaboratorOptionModalSelectedComponent = 'removeCollaborator'
        this.collaboratorOptionModalTitle = 'Remove collaborator'
      }
    },
    truncateUserInformation(userInformation) {
      if (userInformation.length <= 25) {
        return userInformation
      }
      return userInformation.slice(0, 25) + '...'
    },
    clearNotification() {
      db
          .collection('users/' + this.$store.getters.user.data.id + '/notifications')
          .get()
          .then(querySnapshot => {
            querySnapshot.docs.map(doc => doc.ref.delete())
          })
    }
  },
  computed: {
    ...mapGetters([
      "homeSelectedComponent",
      "collaborativeTaskListSelectedTab",
      "creationModalTitle",
      "creationModalSelectedComponent",
      "isCollaborativeListOwner",
      "isCollaborativeListAdministrator"
    ])
  },
  watch: {
    notificationDocuments(newProperties, oldProperties) {
      this.showNotificationPlaceholderImage = this.notificationDocuments.length === 0
    }
  },
  mounted() {
    window.addEventListener("resize", () => this.browserWidth = window.innerWidth)

    // retrieve the notifications
    this.$bind(
        'notificationDocuments',
        db
            .collection('users/' + this.$store.getters.user.data.id + '/notifications')
            .orderBy('notificationCreationDate', 'desc')
    ).then(() => {
      if (this.notificationDocuments.length === 0) {
        this.showNotificationPlaceholderImage = true
      }
      this.hideNotificationPlaceholderWhenInitialLoad = false
    })
  }
}
</script>

<style scoped>
.navbar.navbar-dark.bg-dark {
  background-color: #212441 !important;
}

.navbar-icon {
  font-size: 1.25em;
  color: white;
}

.brand-text {
  margin-left: 0.25em;
}

.logo {
  width: 1.5em;
  margin-right: 0.25em;
}

.profile-picture {
  width: 4em;
  height: 4em;
}

.center-image {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.personal-information-text {
  margin-top: 0.25em;
  margin-bottom: 0.25em;
}

.personal-information-row {
  margin-bottom: 0.5em;
}

.list-category:hover {
  text-decoration: underline;
  cursor: pointer;
}

.active-list-category {
  color: #212441;
  font-weight: bold;
}

.no-notification-container {
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.no-notification-picture {
  width: 250px;
  margin-bottom: 1em;
}

.notification-container {
  height: 81vh;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
}

.clear-notification-button {
  background-color: #212441;
  color: white;
  margin-top: 1em;
}

.clear-notification-button:hover {
  background-color: white;
  color: #212441;
}

.account-details-button {
  background-color: white;
  color: #212441;
  margin-top: 0.25em;
  padding: 0.5em;
  width: 100%;
}

.account-details-button:hover {
  background-color: #212441;
  color: white;
  padding: 0.5em;
}

</style>
